export const knowledgeManagementModule = {
  id: "knowledge-management-enterprise",
  title: "Enterprise Knowledge Management & Information Governance",
  description: "Build knowledge management systems that capture, organize, and share institutional knowledge across enterprise organizations.",
  content: `
## What You'll Learn
By the end of this module, you will be able to:
- Design knowledge management systems that scale with organizational growth
- Implement information governance practices for data quality and compliance
- Create communities of practice that foster knowledge sharing and innovation
- Measure and improve knowledge management effectiveness and ROI

## Prerequisites
- Understanding of enterprise organizational structures
- Experience with information systems and databases
- Knowledge of business process improvement

## Overview
Organizations with effective knowledge management are 25% more likely to outperform competitors. This module teaches systematic approaches to capturing and leveraging institutional knowledge.

---

## Key Concepts

### Knowledge Management Architecture

#### Knowledge Taxonomy
**Classification Systems**: Hierarchical organization of knowledge domains
**Metadata Standards**: Consistent tagging and categorization
**Search and Discovery**: Findable knowledge through multiple access paths
**Personalization**: Customized knowledge delivery based on roles and interests

#### Content Lifecycle
**Creation**: Authoring tools and templates for knowledge capture
**Review and Approval**: Quality assurance and accuracy validation
**Publication**: Distribution channels and access controls
**Maintenance**: Regular updates and obsolescence management

### Information Governance

#### Data Quality Management
**Accuracy Standards**: Validation rules and quality metrics
**Completeness Requirements**: Mandatory fields and information elements
**Consistency Rules**: Standardized formats and terminology
**Timeliness Policies**: Update frequencies and freshness indicators

#### Retention and Disposal
**Retention Schedules**: Lifecycle management for different content types
**Legal Hold Procedures**: Preservation requirements during litigation
**Disposal Methods**: Secure deletion and archival processes
**Audit Trails**: Records of information lifecycle events

---

## Assessment

This module enables organizations to build knowledge management capabilities that drive innovation, efficiency, and competitive advantage.
`,
  duration: 50
};